// extracted by mini-css-extract-plugin
export var csatScore = "_fe-5";
export var header = "_fe-1";
export var panelWrapper = "_fe-2";
export var postPreview = "_fe-3";
export var rightContent = "_fe-0";
export var wrappingText = "_fe-4";